import React from "react";
import AnnouncementBar from "../../../components/AnnouncementBar/AnnouncementBar";
import DocumentIndex from "../../../components/SidetabPages/Documents/DocumentIndex";

const Documents = () => {
  return (
    <>
      <AnnouncementBar />
      <DocumentIndex />
    </>
  );
};
export default Documents;
